import * as z from "zod";

const timePeriodSchema = z.enum([
  "day",
  "week",
  "month",
  "last-month",
  "quarter",
  "all",
  "custom",
]);

const customRangeSchema = z.object({
  start: z.string().min(1),
  end: z.string().min(1),
});

export const myOnboardingStatsSchema = z.object({
  totalOnboardings: z.number().int().min(0),
  weightedRevenueOnboarded: z.number().min(0),
  completedCount: z.number().int().min(0),
  averageCompletionPercent: z.number().min(0).max(100),
});

export const getMyOnboardingStats = {
  name: "getMyOnboardingStats" as const,
  input: z
    .object({
      timePeriod: timePeriodSchema,
      customRange: customRangeSchema.optional(),
      product: z.enum(["returns", "order-editing"]).optional(),
      // Optional: filter by a specific user's email (for viewing other SE's data)
      userEmail: z.string().email().optional(),
    })
    .superRefine((value, ctx) => {
      if (value.timePeriod === "custom" && !value.customRange) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "customRange is required when timePeriod is custom",
          path: ["customRange"],
        });
      }
    }),
  output: myOnboardingStatsSchema,
};

export type MyOnboardingStats = z.infer<typeof myOnboardingStatsSchema>;
export type GetMyOnboardingStatsInput = z.infer<
  typeof getMyOnboardingStats.input
>;
export type GetMyOnboardingStatsOutput = z.infer<
  typeof getMyOnboardingStats.output
>;
